import { render, staticRenderFns } from "./pdf-signature-dialog.vue?vue&type=template&id=22941b10&scoped=true&"
import script from "./pdf-signature-dialog.vue?vue&type=script&lang=ts&"
export * from "./pdf-signature-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./pdf-signature-dialog.vue?vue&type=style&index=0&id=22941b10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22941b10",
  null
  
)

export default component.exports